module.exports = __webpack_public_path__ + "img/file1.0d12017.png";